import { render, staticRenderFns } from "./handcope.vue?vue&type=template&id=240e3927"
import script from "./handcope.vue?vue&type=script&lang=js"
export * from "./handcope.vue?vue&type=script&lang=js"
import style0 from "./handcope.vue?vue&type=style&index=0&id=240e3927&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports